import React from 'react'
import { Tooltip } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { SectionHeader } from '../helpers/SectionHeader'
import { httpToHttps } from '../../utils/helper-functions'

export const SimilarArtists = ( similarArtists ) => {
  const getSimilarArtists = () => {
    let simi = similarArtists?.similarArtists.map( artist => {
      let artistImg = artist?.img1v1Id === 18686200114669622 ? artist?.picUrl : artist?.img1v1Url
      return (
        <Link key={artist.id} to={`/artists/${artist?.id}`}
          style={{
            display: "inline-flex",
            paddingTop: "1rem"
          }} className="playlists__similar">
          <Tooltip
            label={artist?.name}
            aria-label="Tooltip Artist name"
            placement="top"
          >
            <img src={httpToHttps( artistImg + "?param=100y100" )}
              alt={artist?.name}
              style={{
                borderRadius: "1000px",
                width: "120px",
                display: "block",
                margin: "0 0.15rem"
              }}
            />
          </Tooltip>
        </Link>
      )
    } )
    return simi
  }

  return (
    <article>
      <div className="playlists__wrapper">
        <SectionHeader
          title="SIMILAR ARTISTS"
        // iconType="iconBtn"
        // iconOne={<ChevronDownIcon />}
        // iconTwo={null}
        />
        <div className="playlists__horizontal">
          <div className="playlists__inner simi">
            <button className="simi__btn left" aria-label="Left">
            </button>
            {getSimilarArtists()}
            <button className="simi__btn right" aria-label="Right">
            </button>
          </div>
        </div>
      </div>
    </article>
  )
}